import React from 'react';
import NewLanding from './NewLanding';

// Minimal App wrapper now pointing to the new landing experience.
export default function App() {
  return <NewLanding />;
}